module.exports = __webpack_public_path__ + "static/media/Would_you_rather.5a547bfb.jpg";